module.exports = __webpack_public_path__ + "static/media/avatar.2a43541c.jpg";